/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetExperimentsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_experiments_messages.pb'
import {GetExperimentsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_experiments_messages.pb'


export const getProfileExperiments = (request: GetExperimentsRequest, options?: CashRequestOptions) => post<GetExperimentsRequest, GetExperimentsResponse>("/2.0/cash/get-profile-experiments", request, {...options, rejectOnError: true })